exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-login[data-v-51d1a65e]{background-image:url(https://public.riskhub.co.uk/login-bg-v2.png);background-size:cover;background-repeat:no-repeat}", ""]);

// exports
